module.exports = __webpack_public_path__ + "media/images/apple-icon-180x180-1435e373.png";